import { useGetExpiredStocksQuery } from '@/features/slice/inventory';
import { useStockListApiQueryParams } from '@/modules/stocks/shared';

export const useExpiredStockList = () => {
    const queryParams = useStockListApiQueryParams();

    const { data, isFetching, isLoading, isError, error } =
        useGetExpiredStocksQuery(queryParams);

    return {
        data,
        error,
        isFetching,
        isLoading,
        isError,
    };
};
